<div class="iconGallery--icon-list">
  @for (i of placeholder.icons; track i) {
    <div class="iconGallery--icon">
      <div>
        <span class="uilab-icon shimmer"></span>
        <span class="iconGallery--label shimmer"></span>
      </div>
    </div>
  }
</div>
